
// import './App.css';
import React, { Component } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ExpandTable from './components/ExpandTable';
import ExpandTableVicerrector from './components/ExpandTableVicerrector';
import ExpandTableAdministrador from './components/ExpandTableAdministrador';
import ListadoProfesores from './components/ListadoProfesores';
import Delegar from './components/Delegar';
import PadreGraficos from './components/PadreGraficos';
import {
  Route,
  BrowserRouter as Router,
} from 'react-router-dom';
import { Layout } from './components/Layout';
import { AppContext } from './AppContext';
import url from "./components/variables/url.js";
import CasClient, { constant } from "react-cas-client";
import { authService } from './services/auth.service';
import history from "./historyBeta";
import ListadoProfesoresDecano from './components/ListadoProfesoresDecano';
import ListadoProfesoresVicerrector from './components/ListadoProfesoresVicerrector';
import ListadoProfesoresAdministrador from './components/ListadoProfesoresAdministrador';
import AgregarActividad from './components/AgregarActividad';
import Reportes from './components/Reportes';
import Configuracion from './components/Configuracion';

const local = url.localBack;
const CAS_PARAMS = url.cas.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

/* function App() {
  return (
    <Layout>
      <Route exact path="/"> 
        <ListadoProfesores /> 
      </Route>
      <Route path="/profesor/:id"> <ExpandTable /> </Route>
    </Layout>
  );
} */

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);

    this.state = {
      username: null,
      currentUser: null
    };
  }

  componentDidMount() {
    /*console.log("app state = " + JSON.stringify(this.state));*/
    const { username } = this.state;

    if (!username) {
      casClient
        .auth()
        .then(successRes => {
            /*console.log("App successRes = " + JSON.stringify(successRes));*/
            this.setState({ username: successRes.user });
          history.replace(successRes.currentPath);
        })
        .catch(errorRes => { 
          console.log("App errorRes = " + JSON.stringify(errorRes))           
        });
    }

    this.subscription = authService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.idpersona) {
        this.setState({ currentUser: currentUser });
        //console.log(this.state.currentUser.roles);
        //console.log(this.state.currentUser.usuario);
      }
    });
  }

  componentDidUpdate() {
    const { username, currentUser } = this.state;
    if (username && !currentUser) {
      authService.login(username);
    }
  }

  componentWillUnmount() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  logout() {
    casClient.logout();
  }

  render() {
    return (
        <AppContext.Provider value={this.state.currentUser}>            
            <Route path='/Act' render={(props) => <Layout {...props} />} />
            <Route exact path={'/Descargar/:id'} render={(props) => {
                fetch(local + 'File/DescargarDocumento/' + props.match.params["id"], {
                    method: 'GET',
                })
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data !== '') {

                            let a = document.createElement('a');
                            a.href = "data:application/pdf;base64," + data + "";
                            a.download = "evidencia-" + ".pdf";
                            a.click();
                        } else {
                            console.log('Not file');
                        }
                    });
            }
            } />
        <Layout>
          <Route exact path="/">
            <ListadoProfesores />
          </Route>
          <Route path="/Graficos" component={PadreGraficos} />
          <Route path="/Reportes" component={Reportes} />
          <Route path="/profesor/:id"> <ExpandTable /> </Route>
          <Route path="/agregarActividad/:id"> <AgregarActividad /> </Route>
          <Route path="/delegar" component={Delegar} />
          <Route path="/profesores/:tipo/:delegar" component={ListadoProfesores} />
          <Route path="/decano" component={ListadoProfesoresDecano} />
          <Route path="/profesorDecano/:id"> <ExpandTable /> </Route>
          <Route path="/vicerrector" component={ListadoProfesoresVicerrector} />          
          <Route path="/profesorVicerrector/:id"> <ExpandTableVicerrector /> </Route>
                <Route path="/Administrador" component={ListadoProfesoresAdministrador} />
                <Route path="/Configuracion" component={Configuracion} />
          <Route path="/profesorAdministrador/:id"> <ExpandTableAdministrador /> </Route>
        </Layout>
      </AppContext.Provider>
    );
  }
}
